/* eslint-disable arrow-parens */
/* eslint-disable react/prop-types */
import { useState, useCallback, useRef, useEffect, useContext, Suspense } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { CustomDialog } from "../../../../../../../../../shared";
import getAgGridHeight from "../../../../../../../../../../utils/commonFunctions/getAgGridHeight";
import { CellValueChangedEvent, ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";

import { Button } from "@material-ui/core";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import {
	dateConverterToUSFormat,
	dateTimeZoneConverter
} from "../../../../../../../../../../utils/commonFunctions/date";
import {
	handleDateCellRenderer,
	handleDollarCellRenderer
} from "../../../../../../../../../../utils/commonFunctions/cellRenderers";
import { DependentBenefitsGridProps } from "../../../../../../../../../../@types/components/benefitsProps.types";
import { BENEFIT_TERM_REASONS } from "../../../../../../../../../../constants/termReasons";
import { Validation } from "../../../../../../../../../../@types/validation.types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import CustomBenefitEndDialog from "../../../../../../../../../shared/dialogs/customBenefitEndDialog/CustomBenefitEndDialog";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../../../../../utils/api";

const DependentBenefitGridDetails = ({ gridData, benefitType }: DependentBenefitsGridProps) => {
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const [gridHeight, setGridHeight] = useState("300px");
	const agGridRef = useRef<any>(null);
	const [termDetails, setTermDetails] = useState<any>({
		termination_date: "",
		termination_reason: ""
	});
	const [termValidation, setTermValidation] = useState<Validation>({
		termDetails: {},
		status: "invalid"
	});
	const _termValidation = useRef<Validation>();
	const [customTermDateReasonDialogProps, setCustomTermDateReasonDialogProps] = useState<any>({
		openDialog: false,
		title: "Do you want to end this dependent benefit?",
		content:
			"If yes, then this dependent will be removed from the benefit and recalculation of benefit will occur.",
		inputFields: [
			{
				label: "Benefit End Date",
				placeholder: "Enter Benefit End Date",
				name: "termination_date",
				value: termDetails.termination_date,
				type: "date"
			},
			{
				label: "Benefit Term Reason",
				placeholder: "Enter Benefit Termination Reason",
				name: "termination_reason",
				value: termDetails.termination_reason,
				type: "select",
				options: BENEFIT_TERM_REASONS
			}
		],
		actions: [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => {
					handleCloseCustomTermDateReasonDialogClick();
				}
			},
			{
				label: "Submit",
				name: "submit",
				callback: () => null
			}
		]
	});

	const handleOpenTermChangeDialogClick = useCallback(() => {
		setCustomTermDateReasonDialogProps(Object.assign({}, customTermDateReasonDialogProps, { openDialog: true }));
	}, [customTermDateReasonDialogProps]);

	const handleCloseCustomTermDateReasonDialogClick = useCallback(() => {
		const _termDetails = {
			termination_date: null,
			termination_reason: ""
		};
		setTermDetails(Object.assign({}, _termDetails));

		_termValidation.current = {
			termDetails: {
				termination_reason: "",
				termination_date: ""
			},
			status: "valid"
		};
		setTermValidation(Object.assign({}, _termValidation.current));

		setCustomTermDateReasonDialogProps(Object.assign({}, customTermDateReasonDialogProps, { openDialog: false }));
	}, [customTermDateReasonDialogProps]);

	const handleDateChange = useCallback(
		(_date: MaterialUiPickersDate, name: string) => {
			const date = new Date(_date as Date);
			const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
			setTermDetails(Object.assign({}, termDetails, { [name]: parsedDate }));
		},
		[setTermDetails, termDetails]
	);

	const handleTermReasonChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { value } = event.target;
			const { name } = event.target;
			setTermDetails(Object.assign({}, termDetails, { [name]: value }));
		},
		[setTermDetails, termDetails]
	);

	const handleTermValidation = useCallback(async () => {
		const { termination_date, termination_reason } = termDetails;

		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const {
			data: { effective_date }
		} = row;

		_termValidation.current = {
			...termValidation,
			termDetails: {},
			status: "invalid"
		};
		let flag = true;
		if (termination_reason.length === 0) {
			_termValidation.current.termDetails["termination_reason"] = "Benefit End Reason is required";
			_termValidation.current["status"] = "invalid";
			flag = false;
		}

		if (String(termination_date).length === 0) {
			_termValidation.current.termDetails["termination_date"] = "Benefit End Date is required";
			_termValidation.current["status"] = "invalid";
			flag = false;
		}
		// if (termination_date.length !== 0) {
		// 	if (manualDateComparator(effective_date, termination_date) === 1) {
		// 		_termValidation.current.termDetails["termination_date"] =
		// 			"Benefit End Date cannot be less than the Effective Date!";
		// 		_termValidation.current["status"] = "invalid";
		// 		flag = false;
		// 	}
		// }

		if (flag === true) _termValidation.current["status"] = "valid";
		else {
			_termValidation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}
		setTermValidation(Object.assign({}, _termValidation.current));
		return _termValidation.current["status"];
	}, [termDetails, termValidation]);

	const handleBenefitChangeSubmitClick = useCallback(
		async (event: React.MouseEvent<HTMLButtonElement>) => {
			try {
				const benefitTermValidation = await handleTermValidation();
				if (benefitTermValidation === "valid") {
					// console.log("Benefit Term Inside");
					const { termination_date, termination_reason } = termDetails;

					const focusedCell = agGridRef.current.api.getFocusedCell();
					const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
					const {
						data: { plan_name, group_number, insured_SSN, member_SSN, plan_code, effective_date }
					} = row;
					// console.log("_benefitRecalculationPayload", row);
					const _benefitRecalculationPayload = {
						group_number,
						member_SSN,
						insured_SSN,
						termination_reason,
						termination_date,
						// all_group_plans: false,
						// all_VEB_plans: false,
						// specific_group_plans:
						// 	plan_name === "Health Plan"
						// 		? ["Health Plan"]
						// 		: plan_name === "Clinic Card"
						// 		? ["Clinic Card"]
						// 		: [],
						effective_date,
						plan_code: plan_code,
						plan_name: plan_name,
						type: "CORE",
						specific_VEB_plans: []
						// recalculate_group_benefits: true,
						// recalculate_VEB_benefits: false
					};
					console.log("_benefitRecalculationPayload", _benefitRecalculationPayload);

					// alert("This Feature is coming shortly!");
					const response: any = await trackPromise(
						api.enrollments.benefitRecalculationAfterRemovingDependent(_benefitRecalculationPayload)
					);

					if (response) {
						alert(`Dependent is successfully terminated from ${plan_name} and benefit is recalculated!`);
						handleCloseCustomTermDateReasonDialogClick();
						window.location.reload();
					}
				}
			} catch (error) {
				alert("Dependent Termination Unsuccessful!");
				throw error;
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[handleTermValidation, termDetails]
	);

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleBenefitStatusCellRenderer = useCallback(() => {
		return <div>{benefitType}</div>;
	}, [benefitType]);

	const handleActionCellRender = useCallback(() => {
		return (
			<Button className="ag-grid-cell-button " variant="outlined" onClick={handleOpenTermChangeDialogClick}>
				Remove from Plan
			</Button>
		);
	}, [handleOpenTermChangeDialogClick]);

	const handlePlanEndDateCellRenderer = ({ value }: { value: Date | string }) => {
		return <div>{value ? (dateTimeZoneConverter(value as string) as string) : "CURRENT"}</div>;
	};

	useEffect(() => {
		if (termDetails.termination_date === null)
			setTermDetails(Object.assign({}, termDetails, { termination_date: "" }));
	}, [termDetails]);

	useEffect(() => {
		const _customTermDateReasonDialogProps = customTermDateReasonDialogProps;
		_customTermDateReasonDialogProps.inputFields[0].value = termDetails.termination_date;
		_customTermDateReasonDialogProps.inputFields[1].value = termDetails.termination_reason;

		setCustomTermDateReasonDialogProps(Object.assign({}, _customTermDateReasonDialogProps));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [termDetails]);

	useEffect(() => {
		const _gridHeight = getAgGridHeight(gridData.length);
		setGridHeight(_gridHeight);
	}, [gridData.length]);

	// console.log("Dependent gridData", gridData);
	// console.log(gridData.length);

	return (
		<>
			<Suspense fallback={<div />}>
				<CustomBenefitEndDialog
					dialogProps={customTermDateReasonDialogProps}
					handleDateChange={handleDateChange}
					handleTermReasonChange={handleTermReasonChange}
					termValidation={termValidation}
					handleClose={handleCloseCustomTermDateReasonDialogClick}
					handleTermEmployment={handleBenefitChangeSubmitClick}
				/>
			</Suspense>
			<div className="dependent-benefit-details-container">
				<div className="dependent-benefit-details-grid-container glb-tab-grid-container">
					<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
						<AgGridReact
							ref={agGridRef}
							rowData={gridData}
							onGridReady={handleAgGridReady}
							onFirstDataRendered={handleFirstDataRendered}
							rowSelection={"Single"}
							animateRows
							suppressColumnVirtualisation={true}
							defaultColDef={{
								filter: "agTextColumnFilter",
								floatingFilter: true,
								resizable: true
							}}
							enableCellChangeFlash={true}
							frameworkComponents={{
								handleActionCellRender: handleActionCellRender,
								handleDateCellRenderer: handleDateCellRenderer,
								handleDollarCellRenderer: handleDollarCellRenderer,
								handlePlanEndDateCellRenderer: handlePlanEndDateCellRenderer,
								handleBenefitStatusCellRenderer: handleBenefitStatusCellRenderer
							}}
						>
							<AgGridColumn
								field="plan_name"
								headerName="Plan Name"
								floatingFilterComponentParams={{ suppressFilterButton: true }}
								suppressSizeToFit={true}
							></AgGridColumn>
							<AgGridColumn
								field="plan_code"
								headerName="Plan Code"
								floatingFilterComponentParams={{ suppressFilterButton: true }}
							></AgGridColumn>
							<AgGridColumn
								field="enrollment_date"
								headerName="Enrollment Date"
								cellRenderer="handleDateCellRenderer"
								floatingFilterComponentParams={{ suppressFilterButton: true }}
							></AgGridColumn>
							<AgGridColumn
								cellRenderer="handleBenefitStatusCellRenderer"
								headerName="Status"
								suppressSizeToFit={true}
								floatingFilterComponentParams={{ suppressFilterButton: true }}
							></AgGridColumn>
							<AgGridColumn
								field="effective_date"
								headerName="Effective Date"
								cellRenderer="handleDateCellRenderer"
								floatingFilterComponentParams={{ suppressFilterButton: true }}
							></AgGridColumn>
							<AgGridColumn
								// field="benefit_end_date"
								field="termination_date"
								headerName="Benefit End Date"
								cellRenderer="handlePlanEndDateCellRenderer"
								floatingFilterComponentParams={{ suppressFilterButton: true }}
							></AgGridColumn>
							<AgGridColumn
								field="plan_approved_by"
								headerName="Plan Approved By"
								floatingFilterComponentParams={{ suppressFilterButton: true }}
							></AgGridColumn>
							<AgGridColumn
								field="action"
								headerName="Action"
								cellRenderer="handleActionCellRender"
								filter={false}
								suppressSizeToFit={true}
							></AgGridColumn>
						</AgGridReact>
					</div>
				</div>
			</div>
		</>
	);
};

export default DependentBenefitGridDetails;
